
import MultiSceneCommandMeasureClear from './MultiSceneCommandMeasureClear';
import MultiSceneCommandSelectMode from './MultiSceneCommandSelectMode';
import MultiSceneCommandShowPosition from './MultiSceneCommandShowPosition';

export default class MapCommander {

    constructor(options) {
        this._options = options || {};
        this._list = [
            new MultiSceneCommandMeasureClear(),
            new MultiSceneCommandSelectMode(),
            new MultiSceneCommandShowPosition()
        ];
    }

    addCommand(command) {
        this._list.push(command);
    }

    execute(commandDef) {
        let command = this.getCommandByName(commandDef.name);
        if (command) {
            command.execute(this._options.multiSceneViewer, commandDef.params);
            if (this._options.onCommandExecuted) {
                this._options.onCommandExecuted(commandDef.id);
            }
        }
    }

    getCommandByName(name) {
        return this._list.reduce((previous, current) => {
            return (current.getName() === name)
                ? current
                : previous;
        }, null);
    }
}
